/**
 * Lets the browser's back button close an overlay instead of leaving the page.
 * Adds one history entry while the overlay is open and removes it again when the overlay closes some other way.
 */
export class CloseOnBack {
  private hasEntry = false;
  private readonly onPopState = () => {
    if (this.hasEntry) {
      this.hasEntry = false;
      this.close();
    }
  };

  constructor(private readonly win: Window, private readonly close: () => void) {
    win.addEventListener('popstate', this.onPopState);
  }

  opened() {
    if (!this.hasEntry) {
      // Keep the router's state so Angular treats going back as the same page.
      this.win.history.pushState({...(this.win.history.state ?? {}), closeOnBack: true}, '');
      this.hasEntry = true;
    }
  }

  closed() {
    if (this.hasEntry) {
      this.hasEntry = false;
      this.win.history.back();
    }
  }

  dispose() {
    this.win.removeEventListener('popstate', this.onPopState);
  }
}
